import { render, staticRenderFns } from "./ChemUCI51LBA2_M4Q3c.vue?vue&type=template&id=c9ab59c6&"
import script from "./ChemUCI51LBA2_M4Q3c.vue?vue&type=script&lang=js&"
export * from "./ChemUCI51LBA2_M4Q3c.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VForm,VRadio,VRadioGroup,VSimpleTable})
